/* Prop Types */
interface AvatarProps {
  imageUrl: string;
}

/*
 * Avatar component
 */
export const Avatar = ({ imageUrl }: AvatarProps) => {
  return (
    <div className="avatar">
      <div className="w-12 rounded-full">
        <img src={imageUrl} />
      </div>
    </div>
  );
};
